import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { LocaleService } from 'src/app/modules/core/services/locale.service';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session.service';

@Injectable()
export class SetRegisterGuard implements CanActivate {
	constructor(
		private authService: AuthService,
		private sessionService: SessionService,
		private localeService: LocaleService,
		private router: Router
	) {}

	/**
	 * Can current user activates the page
	 *
	 * @param route - Active rout
	 * @param state - Router state
	 * @return
	 */
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		const redirectUrl = route.data['guardRedirectUrl'];
		return this.guardHandling(redirectUrl);
	}

	/**
	 * Guard handling
	 *
	 * @param redirectUrl
	 * @returns
	 */
	private guardHandling(redirectUrl?: string): Observable<boolean> {
		// Return Observable with the logged in status
		return new Observable<boolean>((subscriber) => {
			if (this.sessionService.currentUser) {
				// Data is already set
				subscriber.next(true);
				subscriber.complete();
				return;
			}

			// Set registrator data in session
			this.authService.loginRegistratorUser().subscribe((registratorSet) => {
				if (registratorSet) {
					// Registrator data is set
					subscriber.next(true);
					subscriber.complete();
					return true;
				} else if (redirectUrl) {
					this.router.navigate([redirectUrl]);
				} else {
					this.router.navigate(['/']);
				}

				// Registrator data is not set
				subscriber.next(false);
				subscriber.complete();
				return false;
			});
		});
	}
}
